import React, { Component } from 'react';
import { Redirect } from 'react-router'
import renderHTML from 'react-render-html';
import SliderBrand from './SliderBrand'
import Menu from './Menu'
import RedSocial from './redsocial'
import Contact from './contact'

import { connect } from 'react-redux'
import { initLocation, 
  initMenuAsync, 
  PostCategoryAsync, 
  PagebySlug, 
  PostbyCategorySlug,
  PostbyCategorySlugbyContry,
  PostbyCategorySlugbyContryandPage,
  initPostClear,
  PostCategoryCountryAsync,
  DeletePostbyParametersAction } from './actions'

  import { Icon, Pagination, Preloader } from 'react-materialize';


class CategoryContent extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      menu:[],
      redirect: false,
      starndarpos: false,
      country:'',
      catName:'',
      idCat:'',
      excludeContry:['VE'],
      excludeCountryID:[19],
      excludeCountryInterID:[22],
      menuexclude: false,
      menuSel:'',
      countryId:0,
      selectBrand: [],
      sluCatname: '',
      total: 0,
      display: 2,
      number: 2,
      categoryPathStore: '',
      term_id: '',
      loading: false,
    }
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()
    
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      let nameMenu = `menu-${next_props.country.idtag.slug}`
      let idCo = next_props.country.idtag.term_id
      this.setState({
        country: next_props.country.location,
        menuSel: nameMenu,
        defaultCountry: idCo,
        selectDest: [],
        selectBrand: [],
        selectCase: [],
      })
      this.props.clearPost()
      console.log(next_props.country.idtag.term_id)
      this.props.getCategorybyCountry(12, next_props.country.idtag.term_id)
      this.props.getAllCategorybyCountry(this.props.match.params.categoryPath, next_props.country.idtag.term_id)
      this.setState({
        categoryPathStore: this.props.match.params.categoryPath,
        term_id: next_props.country.idtag.term_id,
      })
    }

    if(next_props.post !== this.state.postObj){
      this.setState({
        loading: true
      })
      let branddata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(12) !== -1
      })

      branddata = branddata.sort(function(a, b){return b.id-a.id})
      
      this.setState({
        selectBrand: branddata
      });

      let post = next_props.post.filter((itemdata) => {
        if (itemdata.categories.indexOf(this.state.idCat) !== -1 && itemdata.tags.indexOf(12) === -1 && itemdata.excerpt.rendered !== ""){
          return true
        }
        return false
      })

      post = post.sort(function(a, b){return b.id-a.id})

      this.setState({
        postObj: post,
        loading: false,
      });
    }


    if(next_props.category){
        next_props.category.map((item, i) =>{
          if(item.count === 0){
            this.setState({
              idCat: item.id,
              catName: item.name,
              sluCatname: item.slug,
              numberCat: 0
            })
          }else{
            this.setState({
              idCat: item.id,
              catName: item.name,
              sluCatname: item.slug
            })
          }
          
          return true;
        })


      }
      
    if(next_props.pageTotal > 0){
      this.setState({
        total: next_props.pageTotal
      })
    }
  }

  getNewPage = (page)=>{
    this.setState({
      loading: true
    })

    this.props.deletePostbyParameters(this.state.idCat, 12, "")
    setTimeout(()=>{
      this.props.getAllCategorybyCountryandPage(this.state.categoryPathStore, this.state.term_id, page)
    }, 500)
  }


  render() {
    if (this.state.redirect && !this.state.contacto){
      return <Redirect to='/error/404'/>;
    }

    return (
      <div className="cont_detail">
        <header className="App-header">
          <div className="">
            <div className="row">
              <div className="col s12 m11 offset-m1 l7 offset-l5 logo">
                <Contact search={false}/>
                <RedSocial search={true}/>
                <Menu slug='locations' select={true}col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defaultCountry}/>
              </div>
              <div className="col s12 m12 l12 nav_principal">
                <Menu slug={this.state.menuSel}  col={12} scrollMenu={true}/>
              </div>
            </div>
          </div>
        </header>
        {
          this.state.sluCatname === 'actualidad-del-mercado' && 
          <section>
            <div className="col s12 ">
              <div className="container">
                <div className="row">
                  <div className="col s12 m12 l12 actu_merc">
                    <div className="header_img"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
        {
          this.state.sluCatname === 'actualidad-del-mercado' && this.state.total > 0 &&
          <section>
            <div className="container">
              <div className="row">
                <div className="col s12 m12 l12 cont-pagination">
                  {
                    this.state.loading &&
                    <Preloader
                    active
                    color="blue"
                    flashing={false}
                    size="small"
                  />
                  }
                  <Pagination
                    activePage={1}
                    items={this.state.total}
                    leftBtn={<Icon>chevron_left</Icon>}
                    maxButtons={5}
                    rightBtn={<Icon>chevron_right</Icon>}
                    onSelect={this.getNewPage}
                  />
                </div>
              </div>
            </div>
          </section>
        }
        <section>
          <div className="col s12 ">
            <div className="container">
              <div className="row">
                <div className={`col s12 m12 ${this.state.sluCatname === 'actualidad-del-mercado'?'l12 cont-cat-actu-list':'l10 cont-cat'} `}>
                {
                  this.state.postObj.map((item, i) => {  
                    return (
                      <div className="item-post-category" key={i}>
                        <a href={item.link}>
                          { item.video_field.length > 0 &&
                            <div className="wrapper-player">
                              <div className="player">
                                <iframe src={item.video_field} title={item.title.rendered} frameborder="0"></iframe>
                              </div>
                            </div>
                          }
                          { item.featured_media > 0 &&
                            <div className={`col s12 ${this.state.sluCatname === 'actualidad-del-mercado'?'m12':'m5'} l5`}>
                              <div className={(item.video_field !== '' && item.video_field !== undefined && item.video_field.length > 0) ? 'item-post-img-play' : 'item-post-img'}>
                                { item.media.media_details && item.media.media_details.sizes.medium && item.media.media_details.sizes.medium.source_url &&
                                  <img src={item.media.media_details.sizes.medium.source_url} alt=""/>
                                }
                              </div>
                            </div>
                          }
                          { item.featured_media > 0 &&
                            <div className={`col s12 ${this.state.sluCatname === 'actualidad-del-mercado'?'m12':'m7'} l7`}>
                              <div className="item-post-cont">
                                <h3>{item.title.rendered}</h3>
                                <div>{renderHTML(item.excerpt.rendered)}</div>
                              </div>
                            </div>
                          }
                          { item.featured_media === 0 &&
                            <div className={`col s12 ${this.state.sluCatname === 'actualidad-del-mercado'?'m12':'m7'} l7`}>
                              <div className="item-post-cont">
                                <h3>{item.title.rendered}</h3>
                                <div>{renderHTML(item.excerpt.rendered)}</div>
                              </div>
                            </div>
                          }
                        </a>
                      </div>
                    )
                  })
                }
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="line_bg"></div>
          <div className="cont_slider_brand">
            <div className="container">
              <div className="row">
                <div className="col s1"></div>
                <div className="col s10">
                  <SliderBrand content={this.state.selectBrand}/>
                </div>
                <div className="col s1"></div>
              </div>
            </div>
          </div>
          <div className="cont_log_footer">
            <div className="container">
              <div className="row">
                <div className="col s12 m7 text_vc">
                  <p>COPYRIGHT @ VC MEDIOS S.A. 2018 > TODOS LOS DERECHOS RESERVADOS</p>
                  <p><a href="/terminos-y-condiciones-politica-de-privacidad/">TERMINOS Y CONDICIONES</a> | <a href="/terminos-y-condiciones-politica-de-privacidad/">POLITICAS DE PRIVACIDAD</a></p>
                </div>
                <div className="col s12 m5 brand_vc">
                  <img className="col s6" src="/assets/images/logo_vc_footer_b.png" alt=""/>
                  <img className="col s6" src="/assets/images/logo_vcDigital_footer_b.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    menus: reducer.menus,
    post: reducer.post,
    country: reducer.country,
    category: reducer.categories,
    pageTotal: reducer.page,
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAllCategorybyId: (data) => dispatch(PostbyCategorySlug(data)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getCategory: (data) => dispatch(PostCategoryAsync(data)),
    getPage: (data) => dispatch(PagebySlug(data)),
    getAllCategorybyCountry: (data, excludeCountry) => dispatch(PostbyCategorySlugbyContry(data, excludeCountry)),
    getAllCategorybyCountryandPage: (data, excludeCountry, page) => dispatch(PostbyCategorySlugbyContryandPage(data, excludeCountry, page)),
    getCategorybyCountry: (data, excludeCountry) => dispatch(PostCategoryCountryAsync(data, excludeCountry)),
    clearPost: (data) => dispatch(initPostClear(data)),
    deletePostbyParameters: (data, tag, validate) => dispatch(DeletePostbyParametersAction(data, tag, validate)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(CategoryContent)



// WEBPACK FOOTER //
// ./src/Categorypost.js